import React, { useState, useEffect } from 'react';
import {
  BookOpen,
  Award,
  Users,
  FileText,
  CheckCircle,
  Mail,
  TrendingUp,
  Globe,
  Star,
  Calendar,
  Send,
  ClipboardCheck,
  Sparkles,
  AlertCircle,
  Network,
  Loader2,
  DollarSign,
  Building2,
  CreditCard,
  ChevronDown,
  ClipboardList
} from 'lucide-react';

const RedesProduccion = () => {
  const [redesData, setRedesData] = useState(null);
  const [datosBancarios, setDatosBancarios] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isArticuloOpen, setIsArticuloOpen] = useState(false);
  const [isMetodologiaOpen, setIsMetodologiaOpen] = useState(false);

  useEffect(() => {
    const cargarDatos = async () => {
      try {
        const [redesRes, generalesRes] = await Promise.all([
          fetch(`/data/redes-estadisticas-fechas.json?v=${Date.now()}`),
          fetch(`/data/generales.json?v=${Date.now()}`)
        ]);

        if (!redesRes.ok || !generalesRes.ok) {
          throw new Error('Error al cargar los datos');
        }

        const redesJson = await redesRes.json();
        const generalesJson = await generalesRes.json();

        setRedesData(redesJson);
        setDatosBancarios(generalesJson.datosBancarios);
      } catch (error) {
        console.error('Error al cargar datos de REDES:', error);
      } finally {
        setIsLoading(false);
      }
    };

    cargarDatos();
  }, []);

  // Función helper para obtener componentes de iconos
  const getIconComponent = (iconName) => {
    const iconMap = {
      'Calendar': Calendar,
      'BookOpen': BookOpen,
      'FileText': FileText,
      'Users': Users,
      'Award': Award,
      'Send': Send,
      'Globe': Globe,
      'CheckCircle': CheckCircle
    };
    return iconMap[iconName] || BookOpen;
  };

  const estadisticas = [
    { numero: '14', texto: 'años publicando libros', icono: Calendar },
    { numero: '175', texto: 'libros publicados', icono: BookOpen },
    { numero: '84', texto: 'libros en extenso', icono: FileText },
    { numero: '1033', texto: 'artículos como capítulo', icono: Users },
    { numero: '354', texto: 'artículos publicados ISBN', icono: Award }
  ];

  const formasParticipacion = [
    {
      titulo: 'Artículo como capítulo de libro digital',
      descripcion: 'Sume su artículo a una publicación electrónica con doble registro ISBN España-México',
      icono: FileText,
      color: '#0b742f'
    },
    {
      titulo: 'Libro en extenso en formato digital',
      descripcion: 'Publique su libro completo con doble registro ISBN y todos los servicios editoriales',
      icono: BookOpen,
      color: '#e87729'
    }
  ];

  const beneficios = [
    'Doble registro ISBN España - México',
    'Publicación en formato digital',
    'Agregado a DIALNET',
    'Sistema DOI (Digital Object Identifier)',
    'Registro ORCID',
    'Indexado en OpenAlex',
    'Revisión por pares de expertos internacionales',
    'Corrección de textos profesional',
    'Maquetación y diagramación',
    'Portada profesional',
    'Constancias de participación',
    'Acceso abierto con licencia Creative Commons CC-BY 4.0',
    'Certificados de evaluación por pares'
  ];

  const areasConocimiento = [
    'Ciencias de la Educación',
    'Ciencias Económicas y Administrativas',
    'Ciencias Experimentales',
    'Ciencias Sociales y Humanidades',
    'Ciencias de la Salud'
  ];

  const serviciosEditoriales = [
    'Corrección de textos',
    'Maquetación - diagramación para libro digital',
    'Informe de lectura de la revisión por pares',
    'Portada profesional para libro digital',
    'ISBN editorial',
    'Constancias de autoría'
  ];

  const organizacionesEditoriales = redesData?.organizacionesEditoriales?.logos || [];

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white">
      {/* Hero Section */}
      <div className="relative bg-gradient-to-r from-[#0b742f] to-[#085a24] text-white py-20 overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PHBhdHRlcm4gaWQ9ImdyaWQiIHdpZHRoPSI2MCIgaGVpZ2h0PSI2MCIgcGF0dGVyblVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+PHBhdGggZD0iTSAxMCAwIEwgMCAwIDAgMTAiIGZpbGw9Im5vbmUiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMSIvPjwvcGF0dGVybj48L2RlZnM+PHJlY3Qgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIgZmlsbD0idXJsKCNncmlkKSIvPjwvc3ZnPg==')] opacity-20"></div>
        </div>

        <div className="relative max-w-7xl mx-auto px-6">
          <div className="flex items-start gap-4 mb-6">
            <div className="bg-white/10 backdrop-blur-sm p-4 rounded-xl">
              <BookOpen className="w-12 h-12" />
            </div>
            <div>
              <h1 className="text-4xl md:text-5xl font-bold mb-4">
                Colección REDES de Producción Académica
              </h1>
              <p className="text-xl md:text-2xl text-white/90">
                Todas nuestras publicaciones con doble registro ISBN España - México
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 py-12">

        {/* Logos 
        <section className="mb-12">
          <div className="bg-gradient-to-br from-gray-50 to-white rounded-2xl p-6 md:p-8 shadow-xl border border-gray-200 relative overflow-hidden">
            <div className="absolute inset-0 bg-gradient-to-r from-[#0077C8]/5 via-transparent to-[#0b742f]/5"></div>
            <div className="relative flex flex-col md:flex-row items-center justify-center gap-8 md:gap-12">
              <div className="group flex flex-col items-center">
                <div className="bg-white rounded-xl p-6 shadow-md hover:shadow-xl transition-all duration-300 transform group-hover:scale-105 border-2 border-transparent hover:border-[#0b742f]/20">
                  <img
                    src="https://recursos.cenid.org/img_cenid/proyecto_catedra.png"
                    alt="Proyecto Cátedra"
                    className="h-24 md:h-32 w-auto object-contain"
                  />
                </div>
                <span className="mt-3 text-sm font-semibold text-gray-600 group-hover:text-[#0b742f] transition-colors">Proyecto Cátedra</span>
              </div>
            </div>
          </div>
        </section>
        */}
        
        {/* Estadísticas y Logo Editorial CENID */}
        <section className="mb-12">
          <div className="bg-white rounded-lg shadow-xl overflow-hidden border-t-4 border-[#0b742f]">
            <div className="p-6 sm:p-8 lg:p-10">
              <div className="flex flex-col lg:flex-row gap-8 lg:gap-12 items-center">
                {/* Logo de Editorial CENID - Izquierda */}
                <div className="lg:w-1/3 flex justify-center lg:justify-start flex-shrink-0">
                  <div className="group flex flex-col items-center">
                    <div className="bg-gradient-to-br from-gray-50 to-white rounded-xl p-6 shadow-md hover:shadow-xl transition-all duration-300 transform group-hover:scale-105 border-2 border-transparent hover:border-[#0b742f]/20">
                      <img
                        src="https://recursos.cenid.org/img_cenid/ed_cenid_verde.png"
                        alt="Editorial CENID"
                        className="h-32 md:h-40 w-auto object-contain"
                      />
                    </div>
                    <span className="mt-3 text-sm font-semibold text-gray-600 group-hover:text-[#0b742f] transition-colors text-center">Editorial CENID</span>
                  </div>
                </div>

                {/* Estadísticas - Derecha */}
                <div className="lg:w-2/3 w-full">
                  <h3 className="text-2xl md:text-3xl font-bold text-gray-900 mb-6 text-center lg:text-left flex items-center justify-center lg:justify-start gap-3">
                    <TrendingUp className="w-8 h-8 text-[#0b742f]" />
                    Colección REDES en números
                  </h3>

                  {isLoading ? (
                    <div className="flex items-center justify-center py-8">
                      <Loader2 className="h-8 w-8 animate-spin text-[#0b742f]" />
                    </div>
                  ) : redesData ? (
                    <div className="space-y-4">
                      {/* Primeras 2 estadísticas destacadas */}
                      {redesData.estadisticas.slice(0, 2).map((stat, index) => {
                        const IconComponent = getIconComponent(stat.icono);
                        return (
                          <div key={index} className={`flex items-center gap-4 p-4 ${stat.colorFondo} rounded-lg border-l-4 ${stat.colorBorde} hover:shadow-lg transition-shadow duration-200`}>
                            <div className="flex-shrink-0 bg-white rounded-full p-3 shadow-md">
                              <IconComponent className={`w-8 h-8 ${stat.colorIcono}`} />
                            </div>
                            <div>
                              <div className={`text-3xl md:text-4xl font-bold ${stat.colorTexto} mb-1`}>{stat.numero} {stat.texto.split(' ')[0]}</div>
                              <p className="text-sm text-gray-600">{stat.descripcion}</p>
                            </div>
                          </div>
                        );
                      })}

                      {/* Grid para las últimas 3 estadísticas */}
                      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 pt-2">
                        {redesData.estadisticas.slice(2).map((stat, index) => {
                          const IconComponent = getIconComponent(stat.icono);
                          return (
                            <div key={index} className={`text-center p-4 ${stat.colorFondo} rounded-lg border-2 ${stat.colorBorde} hover:shadow-lg transition-all duration-200`}>
                              <div className="flex justify-center mb-2">
                                <div className="bg-white rounded-full p-2 shadow-sm">
                                  <IconComponent className={`w-6 h-6 ${stat.colorIcono}`} />
                                </div>
                              </div>
                              <div className={`text-3xl font-bold ${stat.colorTexto} mb-1`}>{stat.numero}</div>
                              <div className="text-xs font-medium text-gray-700">{stat.texto}</div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  ) : (
                    <div className="space-y-4">
                      {/* Fallback con datos estáticos */}
                      <div className="flex items-center gap-4 p-4 bg-gradient-to-r from-green-50 to-emerald-50 rounded-lg border-l-4 border-[#0b742f] hover:shadow-lg transition-shadow duration-200">
                        <div className="flex-shrink-0 bg-white rounded-full p-3 shadow-md">
                          <Calendar className="w-8 h-8 text-[#0b742f]" />
                        </div>
                        <div>
                          <div className="text-3xl md:text-4xl font-bold text-[#0b742f] mb-1">14 años</div>
                          <p className="text-sm text-gray-600">de experiencia en publicaciones académicas</p>
                        </div>
                      </div>

                      <div className="flex items-center gap-4 p-4 bg-gradient-to-r from-blue-50 to-cyan-50 rounded-lg border-l-4 border-blue-600 hover:shadow-lg transition-shadow duration-200">
                        <div className="flex-shrink-0 bg-white rounded-full p-3 shadow-md">
                          <BookOpen className="w-8 h-8 text-blue-600" />
                        </div>
                        <div>
                          <div className="text-3xl md:text-4xl font-bold text-blue-600 mb-1">175 libros</div>
                          <p className="text-sm text-gray-600">publicados en diversas áreas del conocimiento</p>
                        </div>
                      </div>

                      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 pt-2">
                        <div className="text-center p-4 bg-gradient-to-br from-purple-50 to-violet-50 rounded-lg border-2 border-purple-200 hover:border-purple-400 hover:shadow-lg transition-all duration-200">
                          <div className="flex justify-center mb-2">
                            <div className="bg-white rounded-full p-2 shadow-sm">
                              <FileText className="w-6 h-6 text-purple-600" />
                            </div>
                          </div>
                          <div className="text-3xl font-bold text-purple-600 mb-1">84</div>
                          <div className="text-xs font-medium text-gray-700">Libros en extenso</div>
                        </div>
                        <div className="text-center p-4 bg-gradient-to-br from-orange-50 to-amber-50 rounded-lg border-2 border-[#e87729] hover:border-orange-600 hover:shadow-lg transition-all duration-200">
                          <div className="flex justify-center mb-2">
                            <div className="bg-white rounded-full p-2 shadow-sm">
                              <FileText className="w-6 h-6 text-[#e87729]" />
                            </div>
                          </div>
                          <div className="text-3xl font-bold text-[#e87729] mb-1">1033</div>
                          <div className="text-xs font-medium text-gray-700">Artículos publicados</div>
                        </div>
                        <div className="text-center p-4 bg-gradient-to-br from-rose-50 to-pink-50 rounded-lg border-2 border-rose-300 hover:border-rose-400 hover:shadow-lg transition-all duration-200">
                          <div className="flex justify-center mb-2">
                            <div className="bg-white rounded-full p-2 shadow-sm">
                              <Users className="w-6 h-6 text-rose-600" />
                            </div>
                          </div>
                          <div className="text-3xl font-bold text-rose-600 mb-1">354</div>
                          <div className="text-xs font-medium text-gray-700">Autores publicados</div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Convocatoria Redes UNESCO */}
        <section className="mb-12">
          <div className="bg-white rounded-lg shadow-xl overflow-hidden border-l-4 border-[#e87729]">
            <div className="p-8">
              <h2 className="text-3xl font-bold text-gray-900 mb-6 flex items-center gap-3">
                <Sparkles className="w-8 h-8 text-[#e87729]" />
                Convocatoria Redes UNESCO
              </h2>

              <div className="space-y-4">
                <div className="bg-orange-50 p-4 sm:p-6 rounded-lg border-l-4 border-[#e87729]">
                  <p className="text-gray-800 leading-relaxed font-medium mb-4 text-lg">
                    El Centro de Estudios e Investigaciones para el Desarrollo Docente A.C invita a investigadores, académicos y profesionales a la publicación de artículos en la Edición Especial Redes UNESCO misma que servirá a contribuir a la postulación del Proyecto Cátedra UNESCO sobre IA en Análisis e Inclusión del Conocimiento. Se contará con la participación de cinco Cátedras UNESCO de Iberoamérica.
                  </p>

                  {redesData ? (
                    redesData.catedras && (
                      <div className="mt-4">
                        <h4 className="font-bold text-[#e87729] mb-3">Cátedras Participantes:</h4>
                        <ul className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                          {redesData.catedras.map((catedra, idx) => (
                            <li key={idx} className="flex items-start gap-2 text-gray-700 bg-white p-3 rounded shadow-sm border border-orange-100">
                              <CheckCircle className="w-5 h-5 text-[#0b742f] flex-shrink-0 mt-0.5" />
                              <span className="text-sm font-medium">{catedra}</span>
                            </li>
                          ))}
                        </ul>
                      </div>
                    )
                  ) : (
                    <div className="mt-4">
                      <h4 className="font-bold text-[#e87729] mb-3">Cátedras Participantes:</h4>
                      <ul className="grid grid-cols-1 sm:grid-cols-2 gap-3 opacity-50">
                        {["Cargando cátedras...", "Cargando cátedras...", "Cargando cátedras...", "Cargando cátedras..."].map((placeholder, idx) => (
                          <li key={idx} className="flex items-start gap-2 text-gray-500 bg-white p-3 rounded shadow-sm border border-orange-100">
                            <Loader2 className="w-5 h-5 animate-spin text-gray-400 flex-shrink-0 mt-0.5" />
                            <span className="text-sm font-medium">{placeholder}</span>
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                </div>
                <p className="text-gray-700 leading-relaxed">
                  Con registro definitivo de RENIECYT, la editorial del Centro de Estudios e Investigaciones para
                  el Desarrollo Docente, CENID A.C., invita a participar en la compilación, elaboración y publicación
                  de capítulo de libro con comité de arbitraje en formato electrónico con doble registro ISBN de
                  manera conjunta o individual.
                </p>
                <p className="text-gray-700 leading-relaxed">
                  Se ofrece la publicación de artículo como capítulo en libro electrónico coeditado, agregado a
                  <strong> DIALNET</strong>, al sistema <strong>DOI (Digital Object Identifier)</strong>, <strong>ORCID</strong> y <strong>OpenAlex</strong>.
                </p>
                <p className="text-gray-700 leading-relaxed">
                  Cada libro esta coeditado <strong>México – España</strong>, agregado a DIALNET, al sistema DOI
                  (Digital Object Identifier), ORCID y OpenAlex.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* SNII - Importancia del capítulo de libro */}
        <section className="mb-12">
          <div className="bg-white rounded-lg shadow-xl overflow-hidden border-l-4 border-[#0b742f]">
            <div className="p-8">
              <h2 className="text-3xl font-bold text-gray-900 mb-3 flex items-center gap-3">
                <Network className="w-8 h-8 text-[#0b742f]" />
                Capítulo de libro y el SNII
              </h2>
              <p className="text-gray-700 leading-relaxed mb-8">
                Para el <strong>Sistema Nacional de Investigadoras e Investigadores (SNII)</strong>, la publicación de capítulos de libros es un indicador clave de colaboración científica especializada y diversificación del conocimiento. A diferencia de un libro completo, el capítulo demuestra la capacidad del investigador para integrarse a debates colectivos y aportar soluciones específicas dentro de grandes obras de frontera.
              </p>

              <div className="space-y-5">

                {/* Razón 1 */}
                <div className="flex gap-4 p-5 bg-gradient-to-r from-green-50 to-emerald-50 rounded-xl border-l-4 border-[#0b742f]">
                  <div className="flex-shrink-0 bg-[#0b742f] text-white w-10 h-10 rounded-full flex items-center justify-center font-bold text-lg shadow">
                    1
                  </div>
                  <div>
                    <h3 className="text-lg font-bold text-gray-900 mb-2 flex items-center gap-2">
                      <Network className="w-5 h-5 text-[#0b742f]" />
                      Evidencia de Redes de Colaboración e Interdisciplina
                    </h3>
                    <ul className="space-y-2">
                      <li className="flex items-start gap-2 text-gray-700">
                        <CheckCircle className="w-4 h-4 text-[#0b742f] flex-shrink-0 mt-0.5" />
                        <span><strong>Trabajo en equipo:</strong> El SNII valora profundamente que la ciencia no se haga en aislamiento. Participar en un libro colectivo demuestra que el investigador forma parte activa de redes temáticas de investigación nacionales o internacionales.</span>
                      </li>
                      <li className="flex items-start gap-2 text-gray-700">
                        <CheckCircle className="w-4 h-4 text-[#0b742f] flex-shrink-0 mt-0.5" />
                        <span><strong>Sinergia científica:</strong> Permite observar cómo diferentes especialistas abordan un problema complejo desde distintas metodologías o subdisciplinas en un mismo volumen.</span>
                      </li>
                    </ul>
                  </div>
                </div>

                {/* Razón 2 */}
                <div className="flex gap-4 p-5 bg-gradient-to-r from-blue-50 to-cyan-50 rounded-xl border-l-4 border-blue-500">
                  <div className="flex-shrink-0 bg-blue-600 text-white w-10 h-10 rounded-full flex items-center justify-center font-bold text-lg shadow">
                    2
                  </div>
                  <div>
                    <h3 className="text-lg font-bold text-gray-900 mb-2 flex items-center gap-2">
                      <TrendingUp className="w-5 h-5 text-blue-600" />
                      Mayor Agilidad en la Difusión de Avances Específicos
                    </h3>
                    <ul className="space-y-2">
                      <li className="flex items-start gap-2 text-gray-700">
                        <CheckCircle className="w-4 h-4 text-blue-600 flex-shrink-0 mt-0.5" />
                        <span><strong>Punto medio estratégico:</strong> Mientras que un artículo científico puede ser muy acotado y un libro completo tarda años en desarrollarse, el capítulo de libro permite presentar marcos teóricos robustos, estudios de caso detallados o resultados parciales de proyectos de gran envergadura de forma más ágil.</span>
                      </li>
                    </ul>
                  </div>
                </div>

                {/* Razón 3 */}
                <div className="flex gap-4 p-5 bg-gradient-to-r from-orange-50 to-amber-50 rounded-xl border-l-4 border-[#e87729]">
                  <div className="flex-shrink-0 bg-[#e87729] text-white w-10 h-10 rounded-full flex items-center justify-center font-bold text-lg shadow">
                    3
                  </div>
                  <div>
                    <h3 className="text-lg font-bold text-gray-900 mb-2 flex items-center gap-2">
                      <Award className="w-5 h-5 text-[#e87729]" />
                      Fortalecimiento y Rigor de la Producción Científica
                    </h3>
                    <ul className="space-y-2">
                      <li className="flex items-start gap-2 text-gray-700">
                        <CheckCircle className="w-4 h-4 text-[#e87729] flex-shrink-0 mt-0.5" />
                        <span><strong>Dictaminación por pares:</strong> Para que el SNII valide un capítulo de libro, la obra completa debe haber pasado por un proceso estricto de arbitraje ciego externo, respaldado por un comité editorial formal. Esto garantiza el rigor técnico de la aportación.</span>
                      </li>
                      <li className="flex items-start gap-2 text-gray-700">
                        <CheckCircle className="w-4 h-4 text-[#e87729] flex-shrink-0 mt-0.5" />
                        <span><strong>Prestigio editorial:</strong> Suma puntos a la trayectoria si el capítulo está alojado en libros editados por universidades públicas, centros de investigación o editoriales comerciales.</span>
                      </li>
                    </ul>
                  </div>
                </div>

                {/* Razón 4 */}
                <div className="flex gap-4 p-5 bg-gradient-to-r from-purple-50 to-violet-50 rounded-xl border-l-4 border-purple-500">
                  <div className="flex-shrink-0 bg-purple-600 text-white w-10 h-10 rounded-full flex items-center justify-center font-bold text-lg shadow">
                    4
                  </div>
                  <div>
                    <h3 className="text-lg font-bold text-gray-900 mb-2 flex items-center gap-2">
                      <Users className="w-5 h-5 text-purple-600" />
                      Flexibilidad para la Formación de Recursos Humanos
                    </h3>
                    <ul className="space-y-2">
                      <li className="flex items-start gap-2 text-gray-700">
                        <CheckCircle className="w-4 h-4 text-purple-600 flex-shrink-0 mt-0.5" />
                        <span><strong>Mentoría visible:</strong> Es una de las plataformas más comunes y eficientes utilizadas por los investigadores para publicar en coautoría con sus estudiantes de posgrado. El SNII premia esto doblemente: como producción científica y como evidencia de formación de nuevos talentos de la ciencia.</span>
                      </li>
                    </ul>
                  </div>
                </div>

                {/* Razón 5 */}
                <div className="flex gap-4 p-5 bg-gradient-to-r from-rose-50 to-pink-50 rounded-xl border-l-4 border-rose-500">
                  <div className="flex-shrink-0 bg-rose-600 text-white w-10 h-10 rounded-full flex items-center justify-center font-bold text-lg shadow">
                    5
                  </div>
                  <div>
                    <h3 className="text-lg font-bold text-gray-900 mb-2 flex items-center gap-2">
                      <BookOpen className="w-5 h-5 text-rose-600" />
                      Relevancia Crítica en Ciencias Sociales, Humanidades y de la Conducta
                    </h3>
                    <ul className="space-y-2">
                      <li className="flex items-start gap-2 text-gray-700">
                        <CheckCircle className="w-4 h-4 text-rose-600 flex-shrink-0 mt-0.5" />
                        <span><strong>Formato preferente:</strong> En disciplinas como la historia, la filosofía, la sociología o el derecho, los libros colectivos (coordinados o editados) son el vehículo principal de debate. Las comisiones dictaminadoras del SNII de estas áreas otorgan un peso porcentual muy alto a los capítulos, equiparándolos en muchas ocasiones con artículos indexados debido a su profundidad analítica.</span>
                      </li>
                    </ul>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </section>

        {/*
        <section className="mb-12">
          <div className="bg-white rounded-lg shadow-xl overflow-hidden border-l-4 border-[#0b742f]">
            <div className="p-8">
              <h2 className="text-3xl font-bold text-gray-900 mb-6 flex items-center gap-3">
                <Users className="w-8 h-8 text-[#0b742f]" />
                Formas de Participación en REDES
              </h2>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
                {formasParticipacion.map((forma, index) => {
                  const IconComponent = forma.icono;
                  return (
                    <div
                      key={index}
                      className="bg-gradient-to-br from-white to-gray-50 p-6 rounded-lg border-2 border-gray-200 hover:border-[#0b742f] hover:shadow-lg transition-all duration-200"
                    >
                      <div className="flex items-start gap-4 mb-4">
                        <div className="flex-shrink-0">
                          <div className="p-3 rounded-full" style={{ backgroundColor: `${forma.color}15` }}>
                            <IconComponent className="w-8 h-8" style={{ color: forma.color }} />
                          </div>
                        </div>
                        <div className="flex-1">
                          <h3 className="text-xl font-bold text-gray-900 mb-2">
                            {forma.titulo}
                          </h3>
                          <p className="text-gray-700">
                            {forma.descripcion}
                          </p>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>

              <div className="bg-blue-50 border-l-4 border-blue-500 p-6 rounded-r-lg">
                <div className="flex items-start gap-3">
                  <Mail className="w-6 h-6 text-blue-600 flex-shrink-0 mt-1" />
                  <div>
                    <p className="font-semibold text-gray-900 mb-2">Más información:</p>
                    <a
                      href={`mailto:${redesData?.contacto?.email || 'redesdeproduccion@cenid.org'}`}
                      className="text-blue-600 hover:text-blue-800 font-medium transition-colors duration-200"
                    >
                      {redesData?.contacto?.email || 'redesdeproduccion@cenid.org'}
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        */}

        {/* Artículo como Capítulo */}
        <section className="mb-12">
          <div className="bg-white rounded-lg shadow-xl overflow-hidden border-l-4 border-[#0b742f]">
            <div className="p-8">
              <h2 className="text-3xl font-bold text-gray-900 mb-6 flex items-center gap-3">
                <FileText className="w-8 h-8 text-[#0b742f]" />
                Publique con otros autores, sume su artículo como capítulo de libro digital
              </h2>

              <div className="mb-8">
                <div className="bg-gradient-to-r from-blue-50 to-indigo-50 border-l-4 border-blue-500 p-6 rounded-r-lg mb-6">
                  <h3 className="text-xl font-bold text-gray-900 mb-3 flex items-center gap-2">
                    <Users className="w-6 h-6 text-blue-600" />
                    ¿A quién va dirigido?
                  </h3>
                  <p className="text-gray-700 leading-relaxed">
                    Investigadores, académicos y profesionales que desean <strong>incrementar su productividad académica</strong> y
                    compartir sus investigaciones con la comunidad científica internacional a través de publicaciones
                    electrónicas con <strong>doble registro ISBN España-México</strong>.
                  </p>
                </div>

                <h3 className="text-xl font-bold text-gray-900 mb-4">Áreas de conocimiento</h3>
                <p className="text-gray-700 leading-relaxed mb-4">
                  Fomentamos redes de aprendizaje colaborativo en cooperación con investigadores, docentes y
                  profesionales nacionales e internacionales en las siguientes áreas:
                </p>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mb-6">
                  {areasConocimiento.map((area, index) => (
                    <div
                      key={index}
                      className="flex items-center gap-3 bg-gradient-to-r from-[#0b742f]/10 to-[#0b742f]/5 p-4 rounded-lg border-l-4 border-[#0b742f]"
                    >
                      <CheckCircle className="w-5 h-5 text-[#0b742f] flex-shrink-0" />
                      <span className="text-gray-700 font-medium">{area}</span>
                    </div>
                  ))}
                </div>


                {/*
                <div className="bg-green-50 border-l-4 border-[#0b742f] p-6 rounded-r-lg mb-6">
                  <h3 className="text-lg font-bold text-gray-900 mb-2 flex items-center gap-2">
                    <BookOpen className="w-5 h-5 text-[#0b742f]" />
                    Requisito para publicación
                  </h3>
                  <p className="text-gray-700 leading-relaxed">
                    El libro será publicado por Editorial CENID con <strong>doble registro ISBN España-México</strong> cuando
                    el proyecto editorial sea aceptado y se reúna un <strong>mínimo de 8 capítulos</strong>.
                  </p>
                </div>
                
                <div className="bg-gradient-to-r from-orange-50 to-yellow-50 border-l-4 border-[#e87729] p-6 rounded-r-lg mb-6">
                  <h3 className="text-lg font-bold text-gray-900 mb-3 flex items-center gap-2">
                    <Award className="w-5 h-5 text-[#e87729]" />
                    Inversión en su desarrollo profesional
                  </h3>
                  <p className="text-gray-700 leading-relaxed">
                    La cuota de participación cubre los costos de organización, desarrollo editorial y gestión del proyecto.
                    Esta inversión le garantiza una publicación de calidad que fortalece su trayectoria académica y
                    contribuye a la sustentabilidad del proyecto editorial.
                  </p>
                </div>
                */}

                <div className="bg-white border-2 border-[#0b742f] rounded-lg p-6 mb-6">
                  <h3 className="text-xl font-bold text-[#0b742f] mb-4 flex items-center gap-2">
                    <CheckCircle className="w-6 h-6" />
                    Su inversión incluye:
                  </h3>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div className="space-y-3">
                      <div className="flex items-start gap-3">
                        <div className="bg-[#0b742f]/10 p-1.5 rounded-full mt-0.5">
                          <CheckCircle className="w-4 h-4 text-[#0b742f]" />
                        </div>
                        <div>
                          <p className="font-semibold text-gray-900">Publicación digital coeditada</p>
                          <p className="text-sm text-gray-600">Artículo como capítulo en libro electrónico</p>
                        </div>
                      </div>
                      <div className="flex items-start gap-3">
                        <div className="bg-[#0b742f]/10 p-1.5 rounded-full mt-0.5">
                          <CheckCircle className="w-4 h-4 text-[#0b742f]" />
                        </div>
                        <div>
                          <p className="font-semibold text-gray-900">Indexación internacional</p>
                          <p className="text-sm text-gray-600">DIALNET, DOI, ORCID y OpenAlex</p>
                        </div>
                      </div>
                      <div className="flex items-start gap-3">
                        <div className="bg-[#0b742f]/10 p-1.5 rounded-full mt-0.5">
                          <CheckCircle className="w-4 h-4 text-[#0b742f]" />
                        </div>
                        <div>
                          <p className="font-semibold text-gray-900">Revisión académica rigurosa</p>
                          <p className="text-sm text-gray-600">Evaluación por pares expertos internacionales</p>
                        </div>
                      </div>
                    </div>
                    <div className="space-y-3">
                      <div className="flex items-start gap-3">
                        <div className="bg-[#0b742f]/10 p-1.5 rounded-full mt-0.5">
                          <CheckCircle className="w-4 h-4 text-[#0b742f]" />
                        </div>
                        <div>
                          <p className="font-semibold text-gray-900">Archivos digitales completos</p>
                          <p className="text-sm text-gray-600">PDF de interior y portada profesional</p>
                        </div>
                      </div>
                      <div className="flex items-start gap-3">
                        <div className="bg-[#0b742f]/10 p-1.5 rounded-full mt-0.5">
                          <CheckCircle className="w-4 h-4 text-[#0b742f]" />
                        </div>
                        <div>
                          <p className="font-semibold text-gray-900">Triple certificación</p>
                          <p className="text-sm text-gray-600">CENID + Editorial CENID + Evaluación por pares</p>
                        </div>
                      </div>
                      <div className="flex items-start gap-3">
                        <div className="bg-[#0b742f]/10 p-1.5 rounded-full mt-0.5">
                          <CheckCircle className="w-4 h-4 text-[#0b742f]" />
                        </div>
                        <div>
                          <p className="font-semibold text-gray-900">Constancia de participación</p>
                          <p className="text-sm text-gray-600">Documento oficial de publicación</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="bg-gradient-to-r from-blue-50 to-cyan-50 border-l-4 border-blue-500 p-6 rounded-r-lg">
                  <div className="flex items-start gap-3">
                    <Globe className="w-8 h-8 text-blue-600 flex-shrink-0 mt-1" />
                    <div>
                      <h3 className="text-lg font-bold text-gray-900 mb-2">Acceso Abierto - Máxima Visibilidad</h3>
                      <p className="text-gray-700 leading-relaxed mb-3">
                        Su trabajo tendrá <strong>alcance global inmediato</strong>. Desde el momento de publicación,
                        los contenidos estarán disponibles en acceso abierto para <strong>descarga y lectura online
                          sin ningún costo</strong>.
                      </p>
                      <div className="bg-white/70 rounded-lg p-4 border border-blue-200">
                        <p className="text-sm text-gray-700 leading-relaxed">
                          <strong>Licencia Creative Commons CC-BY 4.0:</strong> Permite que su investigación sea compartida
                          libremente, siempre que se cite la fuente original. Esta licencia maximiza el impacto y la
                          difusión de su trabajo académico sin restricciones de uso comercial para consulta.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Cómo preparar su artículo */}
        <section className="mb-12">
          <div className="bg-white rounded-lg shadow-xl overflow-hidden border-l-4 border-[#0b742f]">
            <button
              onClick={() => setIsArticuloOpen(!isArticuloOpen)}
              className="w-full p-8 text-left flex items-center justify-between gap-3 hover:bg-gray-50 transition-colors duration-200"
            >
              <span className="flex items-center gap-3 text-3xl font-bold text-gray-900">
                <ClipboardCheck className="w-8 h-8 text-[#0b742f] flex-shrink-0" />
                Cómo preparar su artículo
              </span>
              <ChevronDown className={`w-7 h-7 text-[#0b742f] flex-shrink-0 transition-transform duration-200 ${isArticuloOpen ? 'rotate-180' : ''}`} />
            </button>

            {isArticuloOpen && (
            <div className="px-8 pb-8">
              <div className="bg-blue-50 border-l-4 border-blue-500 p-6 rounded-r-lg">
                <h3 className="text-lg font-bold text-gray-900 mb-3 flex items-center gap-2">
                  <FileText className="w-5 h-5 text-[#0b742f]" />
                  Lineamientos para autores
                </h3>
                <p className="text-gray-700 leading-relaxed">
                  <strong>Consulte los lineamientos para autores y la tabla de criterios de aceptación</strong> de artículos para capítulo de
                  libro o libros en extenso. Favor de seguir rigurosamente las instrucciones al momento de elaborar su artículo.
                </p>
                <a
                  href="/editorial/ejemplocapitulo"
                  className="inline-block mt-4 px-5 py-2 bg-[#0b742f] text-white rounded-lg font-semibold hover:bg-[#085a24] transition-colors"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Ver ejemplo de capítulo de libro
                </a>
                <div className="bg-yellow-50 border-l-4 border-yellow-500 p-4 rounded-r-lg mt-8">
                  <p className="text-sm text-gray-700">
                    <strong>Importante:</strong> Recuerde que una vez enviado, salvo en algunas situaciones
                    excepcionales, no podrá introducir modificaciones en el documento.
                  </p>
                </div>
              </div>
            </div>
            )}
          </div>
        </section>

        {/* Metodología para publicación */}
        <section className="mb-12">
          <div className="bg-white rounded-lg shadow-xl overflow-hidden border-l-4 border-[#e87729]">
            <button
              onClick={() => setIsMetodologiaOpen(!isMetodologiaOpen)}
              className="w-full p-8 text-left flex items-center justify-between gap-3 hover:bg-gray-50 transition-colors duration-200"
            >
              <span className="flex items-center gap-3 text-3xl font-bold text-gray-900">
                <ClipboardList className="w-8 h-8 text-[#e87729] flex-shrink-0" />
                Metodología para publicación
              </span>
              <ChevronDown className={`w-7 h-7 text-[#e87729] flex-shrink-0 transition-transform duration-200 ${isMetodologiaOpen ? 'rotate-180' : ''}`} />
            </button>

            {isMetodologiaOpen && (
            <div className="px-8 pb-8 space-y-6">

              {/* Fase 1 */}
              <div className="mb-6">
                <div className="bg-[#0b742f] text-white px-4 py-3 rounded-t-lg">
                  <h4 className="text-xl font-bold flex items-center gap-2">
                    <div className="bg-white text-[#0b742f] w-8 h-8 rounded-full flex items-center justify-center font-bold">
                      1
                    </div>
                    Fase 1: Revisión de originalidad
                  </h4>
                </div>
                <div className="bg-gray-50 border-2 border-[#0b742f] border-t-0 rounded-b-lg p-6 space-y-3">
                  <div className="flex items-start gap-3">
                    <Send className="w-5 h-5 text-[#0b742f] flex-shrink-0 mt-0.5" />
                    <p className="text-gray-700">Hacer llegar vía formulario su trabajo en extenso.</p>
                  </div>
                  <div className="flex items-start gap-3">
                    <CheckCircle className="w-5 h-5 text-[#0b742f] flex-shrink-0 mt-0.5" />
                    <p className="text-gray-700">
                      <strong>Revisión por parte del comité editorial</strong> de la originalidad del escrito.
                      Se hará del conocimiento por correo electrónico y mediante carta membretada del resultado
                      en un plazo <strong>no mayor de 25 a 30 días naturales</strong>.
                    </p>
                  </div>
                  <div className="flex items-start gap-3">
                    <AlertCircle className="w-5 h-5 text-orange-500 flex-shrink-0 mt-0.5" />
                    <p className="text-gray-700">
                      En los casos en que el comité editorial encuentre alguna <strong>duplicidad</strong> en el
                      trabajo, se harán llegar por escrito las observaciones encontradas y se otorgarán
                      <strong> 10 días naturales</strong> para volver a enviar el trabajo con las correcciones solicitadas.
                    </p>
                  </div>
                  <div className="flex items-start gap-3">
                    <CheckCircle className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" />
                    <p className="text-gray-700">
                      Si el comité editorial <strong>no encuentra observación alguna</strong>, se procederá con la Fase 2.
                    </p>
                  </div>
                </div>
              </div>

              {/* Fase 2 */}
              <div className="mb-6">
                <div className="bg-[#e87729] text-white px-4 py-3 rounded-t-lg">
                  <h4 className="text-xl font-bold flex items-center gap-2">
                    <div className="bg-white text-[#e87729] w-8 h-8 rounded-full flex items-center justify-center font-bold">
                      2
                    </div>
                    Fase 2: Evaluación por pares
                  </h4>
                </div>
                <div className="bg-gray-50 border-2 border-[#e87729] border-t-0 rounded-b-lg p-6 space-y-3">
                  <div className="flex items-start gap-3">
                    <Users className="w-5 h-5 text-[#e87729] flex-shrink-0 mt-0.5" />
                    <p className="text-gray-700">
                      Una vez que el autor(es) tiene conocimiento del resultado de la Fase 1, se dará inicio al
                      <strong> proceso de evaluación por pares</strong>, mismo que no deberá exceder los
                      <strong> 150 a 240 días naturales</strong> para que el comité editorial reciba las
                      observaciones que los pares hagan a cada artículo.
                    </p>
                  </div>
                  <div className="flex items-start gap-3">
                    <Calendar className="w-5 h-5 text-[#e87729] flex-shrink-0 mt-0.5" />
                    <p className="text-gray-700">
                      El autor(es) tiene la obligación de dar respuesta a cada una de las observaciones en un
                      plazo que <strong>no exceda los 15 días hábiles</strong> una vez que se haga llegar por
                      correo electrónico las recomendaciones que el comité evaluador emita. Se tendrá
                      <strong> hasta dos oportunidades</strong> para cubrir las observaciones del comité evaluador.
                    </p>
                  </div>
                  <div className="flex items-start gap-3">
                    <Award className="w-5 h-5 text-[#e87729] flex-shrink-0 mt-0.5" />
                    <p className="text-gray-700">
                      Una vez que fueron subsanadas las observaciones, el autor(es) tiene <strong>10 días hábiles</strong>
                      a partir de esta fecha para cubrir la cuota de publicación.
                    </p>
                  </div>
                  <div className="flex items-start gap-3">
                    <FileText className="w-5 h-5 text-[#e87729] flex-shrink-0 mt-0.5" />
                    <p className="text-gray-700">
                      Una vez que se haga llegar la ficha escaneada vía correo electrónico, el equipo editorial
                      procederá en un plazo de <strong>30 días</strong> a realizar las revisiones ortográficas de
                      estilo, diagramación y publicación.
                    </p>
                  </div>
                </div>
              </div>

              {/* Nota Importante */}
              <div className="bg-red-50 border-l-4 border-red-500 p-6 rounded-r-lg mb-6">
                <h4 className="text-lg font-bold text-gray-900 mb-2 flex items-center gap-2">
                  <AlertCircle className="w-6 h-6 text-red-500" />
                  Nota importante
                </h4>
                <p className="text-gray-700 leading-relaxed">
                  Se informa que todo trabajo que se haga llegar tiene que <strong>cubrir en su totalidad el
                    proceso metodológico arriba señalado</strong>. No por haber cubierto el monto solicitado para
                  su publicación significa que el autor o los autores quedan exentos de cumplir con las
                  observaciones que se hagan a su trabajo.
                </p>
              </div>

            </div>
            )}
          </div>
        </section>

        {/* Beneficios */}
        <section className="mb-12">
          <div className="bg-white rounded-lg shadow-xl overflow-hidden border-l-4 border-[#0b742f]">
            <div className="p-8">
              <h2 className="text-3xl font-bold text-gray-900 mb-6 flex items-center gap-3">
                <Star className="w-8 h-8 text-[#0b742f]" />
                Beneficios de Publicar con CENID
              </h2>

              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                {beneficios.map((beneficio, index) => (
                  <div
                    key={index}
                    className="flex items-start gap-3 bg-gradient-to-r from-gray-50 to-white p-4 rounded-lg border-2 border-gray-200 hover:border-[#0b742f] hover:shadow-md transition-all duration-200"
                  >
                    <CheckCircle className="w-5 h-5 text-[#0b742f] flex-shrink-0 mt-0.5" />
                    <span className="text-gray-700 font-medium">{beneficio}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* Fechas de envío */}
        <section className="mb-12">
          <div className="bg-white rounded-lg shadow-xl overflow-hidden border-l-4 border-[#e87729]">
            <div className="p-8">
              <h2 className="text-3xl font-bold text-gray-900 mb-6 flex items-center gap-3">
                <Calendar className="w-8 h-8 text-[#e87729]" />
                Fechas de envío de contribuciones
              </h2>

              <div className="space-y-6">
                <div className="bg-yellow-50 border-l-4 border-yellow-500 p-6 rounded-r-lg">
                  {isLoading ? (
                    <div className="flex items-center justify-center py-4">
                      <Loader2 className="h-6 w-6 animate-spin text-[#0b742f]" />
                    </div>
                  ) : redesData ? (
                    <p className="text-gray-700 leading-relaxed" dangerouslySetInnerHTML={{ __html: redesData.fechasEnvio.aviso }} />
                  ) : (
                    <p className="text-gray-700 leading-relaxed">
                      Debido a la gran cantidad de trabajos recibidos y a que el comité editorial ha implementado
                      <strong> nuevos elementos de rigor y calidad</strong> a nuestras publicaciones, se ha tomado la
                      decisión de modificar los periodos de recepción y publicación.
                    </p>
                  )}
                </div>

                {isLoading ? (
                  <div className="flex items-center justify-center py-8">
                    <Loader2 className="h-8 w-8 animate-spin text-[#0b742f]" />
                  </div>
                ) : redesData && redesData.fechasEnvio.calendarios && redesData.fechasEnvio.calendarios.length > 0 ? (
                  <div className="space-y-6">
                    {redesData.fechasEnvio.calendarios.map((calendario, calIndex) => (
                      <div key={calIndex} className="bg-white border-2 border-[#e87729] rounded-lg overflow-hidden">
                        <div className="bg-[#e87729] text-white px-6 py-3">
                          <h3 className="text-xl font-bold">{calendario.titulo}</h3>
                          {calendario.periodo && (
                            <p className="text-sm text-white/90 mt-1">{calendario.periodo}</p>
                          )}
                        </div>
                        <div className="overflow-x-auto">
                          <table className="w-full">
                            <thead className="bg-gray-100">
                              <tr>
                                <th className="px-6 py-4 text-left text-sm font-bold text-gray-900 border-b-2 border-gray-300">
                                  Actividad
                                </th>
                                <th className="px-6 py-4 text-left text-sm font-bold text-gray-900 border-b-2 border-gray-300">
                                  Fecha
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {calendario.fechas.map((fecha, index) => {
                                const IconComponent = getIconComponent(fecha.icono);
                                return (
                                  <tr key={index} className="hover:bg-gray-50 transition-colors">
                                    <td className={`px-6 py-4 ${index < calendario.fechas.length - 1 ? 'border-b border-gray-200' : ''}`}>
                                      <div className="flex items-center gap-2">
                                        <IconComponent className={`w-5 h-5 ${fecha.colorIcono}`} />
                                        <span className="text-gray-700 font-medium">{fecha.actividad}</span>
                                      </div>
                                    </td>
                                    <td className={`px-6 py-4 ${index < calendario.fechas.length - 1 ? 'border-b border-gray-200' : ''}`}>
                                      <span className="text-gray-900 font-bold">{fecha.fecha}</span>
                                    </td>
                                  </tr>
                                );
                              })}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className="bg-blue-50 border-2 border-blue-200 rounded-lg p-8">
                    <div className="flex flex-col items-center justify-center text-center">
                      <Calendar className="w-16 h-16 text-blue-600 mb-4" />
                      <h3 className="text-xl font-bold text-gray-900 mb-3">
                        Calendarios próximamente disponibles
                      </h3>
                      <p className="text-gray-700 mb-4 max-w-md">
                        Los calendarios de convocatorias se actualizarán próximamente. Para conocer las fechas vigentes y más información, comunícate con nosotros.
                      </p>
                      <div className="flex items-center gap-2 bg-white px-6 py-3 rounded-lg border-2 border-blue-300">
                        <Mail className="w-5 h-5 text-blue-600" />
                        <a
                          href={`mailto:${redesData?.contacto?.email || 'redesdeproduccion@cenid.org'}`}
                          className="text-blue-600 hover:text-blue-800 font-semibold transition-colors duration-200"
                        >
                          {redesData?.contacto?.email || 'redesdeproduccion@cenid.org'}
                        </a>
                      </div>
                    </div>
                  </div>
                )}

                {/*
                <div className="bg-gradient-to-r from-blue-50 to-cyan-50 border-l-4 border-blue-500 p-6 rounded-r-lg">
                  <h4 className="text-lg font-bold text-gray-900 mb-3">Lo que incluye su publicación:</h4>
                  {isLoading ? (
                    <div className="flex items-center justify-center py-4">
                      <Loader2 className="h-6 w-6 animate-spin text-[#0b742f]" />
                    </div>
                  ) : redesData ? (
                    <ul className="space-y-2">
                      {redesData.fechasEnvio.loQueIncluye.map((item, index) => (
                        <li key={index} className="flex items-start gap-3">
                          <CheckCircle className="w-5 h-5 text-blue-600 flex-shrink-0 mt-0.5" />
                          <span className="text-gray-700">{item}</span>
                        </li>
                      ))}
                    </ul>
                  ) : (
                    <ul className="space-y-2">
                      <li className="flex items-start gap-3">
                        <CheckCircle className="w-5 h-5 text-blue-600 flex-shrink-0 mt-0.5" />
                        <span className="text-gray-700">
                          Publicación de artículo como capítulo en libro electrónico coeditado
                        </span>
                      </li>
                      <li className="flex items-start gap-3">
                        <CheckCircle className="w-5 h-5 text-blue-600 flex-shrink-0 mt-0.5" />
                        <span className="text-gray-700">
                          Incluido en DIALNET, sistema DOI (Digital Object Identifier), ORCID y OpenAlex
                        </span>
                      </li>
                      <li className="flex items-start gap-3">
                        <CheckCircle className="w-5 h-5 text-blue-600 flex-shrink-0 mt-0.5" />
                        <span className="text-gray-700">
                          Envío por correo electrónico de archivos PDF de interior y portada de la edición
                        </span>
                      </li>
                      <li className="flex items-start gap-3">
                        <CheckCircle className="w-5 h-5 text-blue-600 flex-shrink-0 mt-0.5" />
                        <span className="text-gray-700">
                          Tres certificados de participación: CENID, EDITORIAL CENID y evaluación por pares
                        </span>
                      </li>
                    </ul>
                  )}
                </div>
                */}

                {/* Sección de Costos y Datos Bancarios */}
                <div className="mt-12">

                  {/* Encabezado y condiciones generales */}
                  <div className="mb-6">
                    <h3 className="text-2xl font-bold text-gray-900 mb-4 flex items-center gap-2">
                      <CreditCard className="w-7 h-7 text-[#0b742f]" />
                      Costos e Inscripción
                    </h3>
                    <div className="bg-gray-50 rounded-xl p-4 border border-gray-200 grid grid-cols-1 sm:grid-cols-2 gap-3 text-sm text-gray-700">
                      {(redesData?.costos?.condicionesGenerales ?? [
                        'Cada autor puede participar en un máximo de <strong>2 artículos</strong>',
                        'Cada artículo podrá tener un máximo de <strong>4 autores</strong>',
                        'Todas las personas que consten como autores/as deben abonar la cuota correspondiente',
                      ]).map((condicion, i, arr) => (
                        <div key={i} className={`flex items-start gap-2 ${i === arr.length - 1 ? 'sm:col-span-2' : ''}`}>
                          <CheckCircle className="w-4 h-4 text-[#0b742f] flex-shrink-0 mt-0.5" />
                          <span dangerouslySetInnerHTML={{ __html: condicion }} />
                        </div>
                      ))}
                    </div>
                  </div>

                  {/* Planes */}
                  <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-8">
                    {(redesData?.costos?.planes ?? [
                      {
                        nombre: 'Plan Platino', recomendado: false, estilo: 'platino',
                        precios: [{ monto: '6,000', moneda: 'MXN', descripcion: 'por autor' }],
                        incluye: [
                          'Invitación y constancia de participación como autor',
                          'Publicación del artículo como capítulo de libro con doble registro ISBN y registro DOI en libro y en artículo individual',
                          'Indexación: DOI, ORCID, DIALNET, OpenAlex',
                          'Constancia evaluación revisión pares expertos externos',
                        ]
                      },
                      {
                        nombre: 'Plan ORO', recomendado: true, estilo: 'oro',
                        precios: [
                          { monto: '10,000', moneda: 'MXN', descripcion: 'siendo miembro de la REDUNADI o REDRIEL' },
                          { monto: '13,000', moneda: 'MXN', descripcion: 'No miembros' },
                        ],
                        incluye: [
                          'Invitación y constancia de participación como autor',
                          'Publicación del artículo como capítulo de libro con doble registro ISBN y registro DOI en libro y en artículo individual',
                          'Indexación: DOI, ORCID, DIALNET, OpenAlex',
                          'Constancia evaluación revisión pares expertos externos',
                          'Registro de obra (artículo) ante INDAUTOR',
                          'Una constancia-participación como revisor experto en capítulo de libro o revista de editorial CENID',
                        ]
                      }
                    ]).map((plan, idx) => {
                      const isPlatino = plan.estilo === 'platino';
                      return (
                        <div
                          key={idx}
                          className={`relative text-white rounded-2xl p-7 shadow-xl overflow-hidden ${
                            isPlatino
                              ? 'bg-gradient-to-br from-slate-600 to-slate-800'
                              : 'bg-gradient-to-br from-amber-500 to-yellow-600 ring-4 ring-amber-400/60'
                          }`}
                        >
                          <div className="absolute top-0 right-0 p-4 opacity-10">
                            {isPlatino ? <DollarSign className="w-28 h-28" /> : <Award className="w-28 h-28" />}
                          </div>
                          {plan.recomendado && (
                            <div className="absolute top-4 right-4">
                              <span className="bg-white text-amber-600 text-xs font-extrabold px-3 py-1 rounded-full shadow">Recomendado</span>
                            </div>
                          )}
                          <div className="relative">
                            <div className="inline-flex items-center gap-2 bg-white/20 backdrop-blur-sm px-4 py-1.5 rounded-full text-sm font-bold mb-5">
                              {isPlatino ? <Star className="w-4 h-4" /> : <Award className="w-4 h-4" />}
                              {plan.nombre}
                            </div>
                            <div className="mb-5 space-y-2">
                              {plan.precios.map((precio, pi) => (
                                <div key={pi} className={pi < plan.precios.length - 1 ? 'mb-1' : ''}>
                                  <div className={`font-extrabold ${isPlatino ? 'text-4xl md:text-5xl' : 'text-3xl md:text-4xl'}`}>
                                    ${precio.monto}<span className="text-lg font-normal opacity-80 ml-1">{precio.moneda}</span>
                                  </div>
                                  <p className={`text-xs mt-0.5 ${isPlatino ? 'text-slate-300' : 'text-yellow-100'}`}>{precio.descripcion}</p>
                                </div>
                              ))}
                            </div>
                            <ul className="space-y-2.5">
                              {plan.incluye.map((item, i) => (
                                <li key={i} className="flex items-start gap-2 text-sm">
                                  <CheckCircle className={`w-4 h-4 flex-shrink-0 mt-0.5 ${isPlatino ? 'text-slate-300' : 'text-yellow-200'}`} />
                                  <span className={isPlatino ? 'text-slate-200' : 'text-yellow-50'}>{item}</span>
                                </li>
                              ))}
                            </ul>
                          </div>
                        </div>
                      );
                    })}
                  </div>

                  {/* Datos Bancarios */}
                  {datosBancarios && (
                    <div className="bg-white border-2 border-gray-100 rounded-2xl p-8 shadow-lg">
                      <div className="flex items-center gap-3 mb-6">
                        <div className="bg-blue-50 p-3 rounded-xl">
                          <Building2 className="w-8 h-8 text-blue-600" />
                        </div>
                        <h3 className="text-2xl font-bold text-gray-900">Datos Bancarios</h3>
                      </div>
                      <div className="grid grid-cols-1 gap-4">
                        <div className="p-4 bg-gray-50 rounded-xl border border-gray-100">
                          <p className="text-xs text-gray-500 uppercase font-semibold mb-1">Titular</p>
                          <p className="text-sm font-bold text-gray-900 leading-tight">{datosBancarios.titular}</p>
                        </div>
                        <div className="grid grid-cols-2 gap-4">
                          <div className="p-4 bg-gray-50 rounded-xl border border-gray-100">
                            <p className="text-xs text-gray-500 uppercase font-semibold mb-1">Banco</p>
                            <p className="text-sm font-bold text-gray-900">{datosBancarios.banco}</p>
                          </div>
                          <div className="p-4 bg-gray-50 rounded-xl border border-gray-100">
                            <p className="text-xs text-gray-500 uppercase font-semibold mb-1">Cuenta</p>
                            <p className="text-sm font-bold text-gray-900">{datosBancarios.numeroCuenta}</p>
                          </div>
                        </div>
                        <div className="p-4 bg-blue-50 rounded-xl border border-blue-100">
                          <p className="text-xs text-blue-600 uppercase font-semibold mb-1">CLABE Interbancaria</p>
                          <p className="text-base font-bold text-blue-900 tracking-wider">{datosBancarios.clabe}</p>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Libro en Extenso */}
        {/*
        <section className="mb-12">
          <div className="bg-white rounded-lg shadow-xl overflow-hidden border-l-4 border-[#e87729]">
            <div className="p-8">
              <h2 className="text-3xl font-bold text-gray-900 mb-6 flex items-center gap-3">
                <BookOpen className="w-8 h-8 text-[#e87729]" />
                Libro en extenso en formato digital y doble registro
              </h2>

              <div className="mb-6">
                <p className="text-gray-700 text-lg leading-relaxed mb-4">
                  Forme parte de un proyecto editorial compatible con su línea general de conocimiento y háganos
                  llegar su artículo para que se agregue como capítulo de libro electrónico y logre publicar junto
                  con otros autores.
                </p>

                <div className="bg-orange-50 border-l-4 border-[#e87729] p-6 rounded-r-lg mb-6">
                  <p className="text-gray-700 leading-relaxed">
                    <strong>Cuando el proyecto editorial sea aceptado y se reúna el número mínimo de ocho capítulos</strong> se
                    publicará en Editorial CENID con doble registro ISBN España-México.
                  </p>
                </div>

                <div className="bg-gradient-to-r from-gray-50 to-white p-6 rounded-lg border-2 border-gray-200 mb-6">
                  <h3 className="text-xl font-bold text-gray-900 mb-4 flex items-center gap-2">
                    <TrendingUp className="w-6 h-6 text-[#e87729]" />
                    Experiencia Editorial
                  </h3>
                  {isLoading ? (
                    <div className="flex items-center justify-center py-4">
                      <Loader2 className="h-6 w-6 animate-spin text-[#0b742f]" />
                    </div>
                  ) : redesData ? (
                    (redesData.estadisticas && redesData.estadisticas[0] && redesData.estadisticas[1]) ? (
                      <p className="text-gray-700 leading-relaxed mb-4">
                        En Editorial CENID llevamos <strong>{redesData.estadisticas[0].numero} {redesData.estadisticas[0].texto}</strong>, actualmente tenemos
                        <strong> {redesData.estadisticas[1].numero} {redesData.estadisticas[1].texto}</strong> en formato impreso y digital. A partir del 2022 solo se publican
                        libros digitales.
                      </p>
                    ) : (
                      <div className="bg-red-100 border-l-4 border-red-500 text-red-700 p-4 rounded mb-4">
                        Error: No se encontraron datos de estadísticas en la fuente de datos.
                      </div>
                    )
                  ) : (
                    <div className="bg-red-100 border-l-4 border-red-500 text-red-700 p-4 rounded mb-4">
                      Error: No se pudo cargar la información de estadísticas.
                    </div>
                  )}
                </div>

                <div className="bg-gray-50 p-6 rounded-lg mb-6">
                  <h3 className="text-xl font-bold text-gray-900 mb-4">Nuestro trabajo editorial cubre todos los aspectos:</h3>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                    {serviciosEditoriales && serviciosEditoriales.length > 0 ? (
                      serviciosEditoriales.map((servicio, index) => (
                        <div key={index} className="flex items-start gap-3">
                          <CheckCircle className="w-5 h-5 text-[#e87729] flex-shrink-0 mt-0.5" />
                          <span className="text-gray-700">{servicio}</span>
                        </div>
                      ))
                    ) : (
                      <div className="bg-red-100 border-l-4 border-red-500 text-red-700 p-4 rounded mb-4 col-span-2">
                        Error: No se encontraron servicios editoriales.
                      </div>
                    )}
                  </div>
                </div>

                <div className="bg-blue-50 border-l-4 border-blue-500 p-6 rounded-r-lg">
                  <div className="flex items-start gap-3">
                    <Mail className="w-6 h-6 text-blue-600 flex-shrink-0 mt-1" />
                    <div>
                      {isLoading ? (
                        <div className="flex items-center gap-2">
                          <Loader2 className="h-5 w-5 animate-spin text-[#0b742f]" />
                          <span className="text-gray-700">Cargando contacto...</span>
                        </div>
                      ) : redesData && redesData.contacto && redesData.contacto.email ? (
                        <p className="text-gray-700 leading-relaxed">
                          Háganos llegar su artículo vía correo{' '}
                          <a
                            href={`mailto:${redesData.contacto.email}`}
                            className="text-blue-600 hover:text-blue-800 font-semibold transition-colors duration-200"
                          >
                            {redesData.contacto.email}
                          </a>
                          {' '}y recibirá <strong>a la vuelta de tres días su presupuesto</strong>.
                        </p>
                      ) : (
                        <div className="bg-red-100 border-l-4 border-red-500 text-red-700 p-4 rounded mb-4">
                          Error: No se encontró el correo de contacto.
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        */}

        {/* Editorial CENID forma parte de */}
        <section className="mb-12">
          <div className="bg-white rounded-lg shadow-xl overflow-hidden border-l-4 border-[#0b742f]">
            <div className="p-8">
              <h2 className="text-3xl font-bold text-gray-900 mb-6 text-center flex items-center justify-center gap-3">
                <Award className="w-8 h-8 text-[#0b742f]" />
                Editorial CENID forma parte de
              </h2>

              <p className="text-center text-gray-700 text-lg mb-8 max-w-3xl mx-auto">
                {redesData?.organizacionesEditoriales?.descripcion || 'Nos enorgullece ser parte de las principales organizaciones internacionales de acceso abierto y gestión académica, garantizando la calidad y visibilidad de sus publicaciones.'}
              </p>

              <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-6 items-center">
                {organizacionesEditoriales.map((logo, index) => (
                  <div
                    key={`${logo.alt || logo.nombre || 'organizacion'}-${index}`}
                    className="flex flex-col items-center justify-center p-4 bg-gradient-to-br from-gray-50 to-white rounded-lg border-2 border-gray-200 hover:border-[#0b742f] hover:shadow-lg transition-all duration-200 min-h-[140px]"
                  >
                    <img
                      src={logo.src}
                      alt={logo.alt || logo.nombre || `Organización ${index + 1}`}
                      className={logo.className || 'h-16 w-auto object-contain'}
                      onError={(e) => {
                        e.target.style.display = 'none';
                        e.target.nextElementSibling.style.display = 'flex';
                      }}
                    />
                    <div className="text-center" style={{ display: 'none' }}>
                      {(logo.fallbackLines || [logo.nombre || logo.alt || `Organización ${index + 1}`]).map((line, lineIndex) => (
                        <p
                          key={lineIndex}
                          className={`font-bold text-gray-900 ${line.length > 12 ? 'text-xs leading-tight' : 'text-sm'}`}
                        >
                          {line}
                        </p>
                      ))}
                    </div>
                  </div>
                ))}
              </div>

              <div className="mt-8 grid grid-cols-1 md:grid-cols-3 gap-6">
                <div className="bg-gradient-to-r from-blue-50 to-indigo-50 p-6 rounded-lg border-l-4 border-blue-500">
                  <div className="flex items-center gap-3 mb-2">
                    <Globe className="w-5 h-5 text-blue-600" />
                    <h3 className="font-bold text-gray-900">Alcance Global</h3>
                  </div>
                  <p className="text-sm text-gray-700">
                    Sus publicaciones son indexadas en las principales bases de datos académicas internacionales.
                  </p>
                </div>

                <div className="bg-gradient-to-r from-green-50 to-emerald-50 p-6 rounded-lg border-l-4 border-green-500">
                  <div className="flex items-center gap-3 mb-2">
                    <CheckCircle className="w-5 h-5 text-green-600" />
                    <h3 className="font-bold text-gray-900">Calidad Certificada</h3>
                  </div>
                  <p className="text-sm text-gray-700">
                    Respaldados por organizaciones que garantizan estándares internacionales de calidad editorial.
                  </p>
                </div>

                <div className="bg-gradient-to-r from-orange-50 to-yellow-50 p-6 rounded-lg border-l-4 border-orange-500">
                  <div className="flex items-center gap-3 mb-2">
                    <Award className="w-5 h-5 text-orange-600" />
                    <h3 className="font-bold text-gray-900">Reconocimiento Académico</h3>
                  </div>
                  <p className="text-sm text-gray-700">
                    Su trabajo obtiene la visibilidad y el reconocimiento que merece en la comunidad científica.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* CTA Final */}
        <section>
          <div className="bg-gradient-to-r from-[#0b742f] to-[#085a24] text-white rounded-lg shadow-xl p-8">
            <div className="text-center max-w-3xl mx-auto">
              <Send className="w-12 h-12 mx-auto mb-4" />
              <h2 className="text-3xl font-bold mb-4">
                ¿Listo para publicar su investigación?
              </h2>
              <p className="text-xl text-white/90 mb-6">
                Forme parte de nuestra red de producción académica y comparta su conocimiento con la comunidad internacional.
              </p>
              <div className="flex flex-col md:flex-row gap-4 justify-center items-center">
                <a
                  href={`mailto:${redesData?.contacto?.email || 'redesdeproduccion@cenid.org'}`}
                  className="bg-white text-[#0b742f] px-8 py-4 rounded-lg font-bold text-lg hover:bg-gray-100 transition-colors duration-200 flex items-center gap-2 shadow-lg"
                >
                  <Mail className="w-5 h-5" />
                  Contactar Editorial CENID
                </a>
              </div>
              <div className="bg-blue-50 border-l-4 border-blue-500 p-6 rounded-r-lg mt-8">
                <div className="flex items-start gap-3">
                  <Mail className="w-6 h-6 text-blue-600 flex-shrink-0 mt-1" />
                  <div>
                    {isLoading ? (
                      <div className="flex items-center gap-2">
                        <Loader2 className="h-5 w-5 animate-spin text-[#0b742f]" />
                        <span className="text-gray-700">Cargando contacto...</span>
                      </div>
                    ) : redesData && redesData.contacto && redesData.contacto.email ? (
                      <p className="text-gray-700 leading-relaxed">
                        Háganos llegar su artículo vía correo{' '}
                        <a
                          href={`mailto:${redesData.contacto.email}`}
                          className="text-blue-600 hover:text-blue-800 font-semibold transition-colors duration-200"
                        >
                          {redesData.contacto.email}
                        </a>
                        {' '}y recibirá <strong>a la vuelta de tres días su presupuesto</strong>.
                      </p>
                    ) : (
                      <div className="bg-red-100 border-l-4 border-red-500 text-red-700 p-4 rounded mb-4">
                        Error: No se encontró el correo de contacto.
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

      </div>
    </div>
  );
};

export default RedesProduccion;
